import React, { useState, useEffect } from 'react';
import axios from 'axios';

const MailAyarlariPage = () => {
  const [form, setForm] = useState({ MAIL_HOST: '', MAIL_PORT: '', MAIL_USER: '', MAIL_PASS: '', MUHASEBECI_MAIL: '', HR_MAIL: '' });
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sonuc, setSonuc] = useState(null);
  const [sifreGoster, setSifreGoster] = useState(false);

  useEffect(() => {
    axios.get('/api/admin/mail-ayarlari').then(r => setForm(r.data)).catch(console.error);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/admin/mail-ayarlari', form);
      setSonuc({ tip: 'basari', mesaj: 'Mail ayarları güncellendi. Backend yeniden başlatıldığında geçerli olacak.' });
    } catch(err) {
      setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata oluştu.' });
    } finally { setYukleniyor(false); }
  };

  const handleTest = async () => {
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.post('/api/admin/mail-test', { email: form.MAIL_USER });
      setSonuc({ tip: 'basari', mesaj: 'Test maili gönderildi! Gelen kutunuzu kontrol edin.' });
    } catch(err) {
      setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Mail gönderilemedi.' });
    } finally { setYukleniyor(false); }
  };

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Mail Ayarları</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>SMTP ve bildirim mail adreslerini yapılandırın.</p>
      </div>
      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}
      <div className="card">
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.25rem' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '1rem' }}>SMTP Ayarları</p>
            <div className="form-grid">
              <div className="form-group">
                <label>SMTP Sunucusu</label>
                <input type="text" value={form.MAIL_HOST} onChange={e => setForm({ ...form, MAIL_HOST: e.target.value })} placeholder="smtp.gmail.com" />
              </div>
              <div className="form-group">
                <label>Port</label>
                <input type="text" value={form.MAIL_PORT} onChange={e => setForm({ ...form, MAIL_PORT: e.target.value })} placeholder="587" />
              </div>
              <div className="form-group">
                <label>Mail Adresi</label>
                <input type="email" value={form.MAIL_USER} onChange={e => setForm({ ...form, MAIL_USER: e.target.value })} placeholder="sistem@firma.com" />
              </div>
              <div className="form-group">
                <label>Şifre / Uygulama Şifresi</label>
                <div style={{ position: 'relative' }}>
                  <input type={sifreGoster ? 'text' : 'password'} value={form.MAIL_PASS} onChange={e => setForm({ ...form, MAIL_PASS: e.target.value })} placeholder="••••••••••••••••" style={{ width: '100%', paddingRight: '80px' }} />
                  <button type="button" onClick={() => setSifreGoster(!sifreGoster)} style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '12px', color: 'var(--yazi-ikincil)' }}>
                    {sifreGoster ? 'Gizle' : 'Göster'}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div style={{ borderTop: '1px solid var(--border)', paddingTop: '1.25rem', marginBottom: '1.25rem' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '1rem' }}>Bildirim Adresleri</p>
            <div className="form-grid">
              <div className="form-group">
                <label>Muhasebeci Mail</label>
                <input type="email" value={form.MUHASEBECI_MAIL} onChange={e => setForm({ ...form, MUHASEBECI_MAIL: e.target.value })} placeholder="muhasebe@firma.com" />
              </div>
              <div className="form-group">
                <label>HR Mail</label>
                <input type="email" value={form.HR_MAIL} onChange={e => setForm({ ...form, HR_MAIL: e.target.value })} placeholder="hr@firma.com" />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
            <button type="button" className="btn btn-secondary" disabled={yukleniyor} onClick={handleTest}>Test Maili Gönder</button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default MailAyarlariPage;
